"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLabelCartEditOrderDetailsEnum = void 0;
var EventLabelCartEditOrderDetailsEnum;
(function (EventLabelCartEditOrderDetailsEnum) {
    EventLabelCartEditOrderDetailsEnum["Address"] = "Address";
    EventLabelCartEditOrderDetailsEnum["AddressEditConfirmationMessage"] = "Address_ConfirmationMessage";
    EventLabelCartEditOrderDetailsEnum["AddressEditConfirmation"] = "Address_Confirmation";
    EventLabelCartEditOrderDetailsEnum["AddressEditCancellation"] = "Address_Cancellation";
    EventLabelCartEditOrderDetailsEnum["Payment"] = "Payment";
    EventLabelCartEditOrderDetailsEnum["PaymentEditConfirmationMessage"] = "Payment_ConfirmationMessage";
    EventLabelCartEditOrderDetailsEnum["PaymentEditConfirmation"] = "Payment_Confirmation";
    EventLabelCartEditOrderDetailsEnum["PaymentEditCancellation"] = "Payment_Cancellation";
    EventLabelCartEditOrderDetailsEnum["Shipping"] = "Delivery";
    EventLabelCartEditOrderDetailsEnum["Product"] = "Product";
    EventLabelCartEditOrderDetailsEnum["GiftWrap"] = "Giftwrap";
})(EventLabelCartEditOrderDetailsEnum || (exports.EventLabelCartEditOrderDetailsEnum = EventLabelCartEditOrderDetailsEnum = {}));
//# sourceMappingURL=EventLabelCartEditOrderDetailsEnum.js.map